import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/SectionHeading";
import { PHILOSOPHY } from "@/lib/content";

export function Philosophy() {
  return (
    <section className="relative py-28 sm:py-36" data-testid="philosophy">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHeading
          eyebrow="Notre philosophie"
          lines={["Ce que nous apportons", "à chaque entreprise."]}
          className="mb-16"
        />
        <div className="divide-y divide-white/10 border-y border-white/10">
          {PHILOSOPHY.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.05}>
              <div className="group grid grid-cols-1 md:grid-cols-[auto_1fr_2fr] gap-4 md:gap-10 items-baseline py-7 transition-colors hover:bg-white/[0.02] px-2 -mx-2 rounded-lg">
                <span className="font-mono text-xs text-gold">0{i + 1}</span>
                <h3 className="font-serif text-2xl sm:text-4xl text-white group-hover:text-gold transition-colors duration-300">
                  {p.title}
                </h3>
                <p className="text-base text-[var(--txt-2)] font-light leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
